<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
    <form>
        <div class="bg-white rounded-xl p-4 flex items-center gap-4">
            <div class="flex items-center gap-2 w-full">
                <img src="../../assets/image/search.svg" alt="" class="" />
                <input placeholder="Search Concern Type  Here..." class="w-full border p-2 rounded-md outline-none"
                    placeholder="Search User" matInput (input)="applyFilter($event)" />
            </div>
            <div class="w-80">
                <select style="background: #4d4de6;"
                    class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
                    (change)="filterByStatus($event)">


                    <option value="">All</option>
                    <option value="Pending">Pending</option>
                    <option value="Verified">Verified</option>
                    <option value="Rejected">Rejected</option>
                </select>
            </div>

            <div class="w-60">
                <app-primary-button (click)="addNewPackage()" class="flex w-40">
                    <div class="flex space-x-2">
                        <img src="../../../../assets/image/+.svg" alt="" />
                        <span>Add Package</span>
                    </div>
                </app-primary-button>
            </div>
        </div>
    </form>
    <mat-card>
        <mat-card-title>Packages</mat-card-title>
        
        <div class="bg-white rounded-2xl shadow-md p-4">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 w-full">

                <!-- ID Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> ID </th>
                    <td mat-cell *matCellDef="let pkg"> {{pkg.id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="package_name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let pkg"> {{pkg.package_name}} </td>
                </ng-container>

                <!-- Amount -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Sqr Amount </th>
                    <td mat-cell *matCellDef="let pkg"> ₹{{pkg.sqr_amount}} </td>
                </ng-container>

                <!-- Duration -->
                <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef> Duration (Months) </th>
                    <td mat-cell *matCellDef="let pkg"> {{pkg.duration}} </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let pkg">
                        <button mat-icon-button color="primary" (click)="editPackage(pkg.id)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="deletePackage(pkg.id)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>


        <mat-paginator [length]="dataSource" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
        </mat-paginator>
    </mat-card>
</div>